import { z } from 'zod';

export const dataConstants = {
	COGSWORTH_ID: 'cogsworthId',
	COGSWORTH_APPOINTMENT_TIME: 'cogsworthAppointmentTime',
	BRIEF: 'brief',
	EXTENDED: 'extended',
};

export const testContent = {};

export const schema = z.object({});
